import SmartLoading from './SmartLoading';

export { SmartLoading };
export default SmartLoading;
